var $ = jQuery.noConflict();
import _gallery from './../vendor/jquery.swipebox.min';

var swipebox_image_text;

if ( $( ".blog-galeria" ).length ) {

    $( '.blog-galeria a' ).swipebox({
        useSVG : false,
        afterOpen : modalOpen,
        afterClose : modalClose
    });

}
if ( $( ".column-image-text .lightbox .photo" ).length ) {
  if($('.offers-gallery').length) {
    $( '.column-image-text .lightbox a' ).swipebox();
  } else {
    $( '.column-image-text .lightbox a' ).swipebox({
      useSVG : false,
      afterOpen : modalOpen,
      afterClose : modalClose
  });
  }
 
}


$(document.body).on('click touchend','#swipebox-slider .current img', function(e){
	return false;
}).on('click touchend','#swipebox-slider .current', function(e){
	$('#swipebox-close').trigger('click');
})

function modalOpen(){
  var hash = "gallery";
  window.location.hash = hash;
  window.onhashchange = function() {
    if (!location.hash){
      $('#swipebox-close').trigger('click');
    }
  }
}

function modalClose(){
  if( window.location.hash=="#gallery"){
    window.history.back();
  }
}